import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

import '../Styles/UploadKey.css';

const UploadButton = ({ onFileUpload }) => {
  const fileInputRef = useRef();
  const [uploaded, setUploaded] = useState(false);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      // Process the selected file
      console.log('Selected file:', file);
      onFileUpload(file); // Call the callback function to send it to the parent
      setUploaded(true);
    } else {
      setUploaded(false);
    }
    const BUTTON = document.getElementById("refreshData");
    BUTTON.classList.remove("disabled");
  };


  return (
    <div>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        accept=".bin"
      />
      <button className="primary-button uploadKey-button" onClick={handleClick}>
        {uploaded && (
          <FontAwesomeIcon
            icon={faCheck}
            style={{ color: 'green', marginRight: '5px' }}
          />
        )}
        Cipher Key
      </button>
    </div>
  );
};

UploadButton.propTypes = {
    onFileUpload: PropTypes.func.isRequired,
  };

export default UploadButton;